import Header from "./Header/Header";
import { useLocation } from 'react-router-dom';

const Layout =({children}) =>{
    const location = useLocation();
    const hideHeader = location.pathname === '/';
    return(
        <>
            {!hideHeader && <Header/>}
            <main>{children}</main>
            {/* <Footer/> */}
        </>
    )
}

export default Layout;